import React, { useContext, useEffect, useState } from "react";
import "../../../../assests/css/admin/AdminLogin/AdminLogin.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const AdminLogin = () => {

  const { baseUrl, regExpChecker } = useContext(AppContext);
  const navigate = useNavigate();

  const [email, setEmail]               = useState("");
  const [password, setPassword]         = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState("");
  const [isAutoLogging, setIsAutoLogging] = useState(true);

 
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      navigate("/admin/dashboard", { replace: true });
    } else {
      setIsAutoLogging(false);
    }
  }, []);

 
  const clearAdminSession = () => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminemail");
  localStorage.removeItem("adminUser");
  localStorage.removeItem("adminId");
};

  const adminLogin = (Email, Password) => {
    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("email", Email);
    formData.append("password", Password);

    axios.post(`${baseUrl}/admin/login`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then((response) => {
        setLoading(false);

      if (response.data.success) {
  localStorage.setItem("adminToken", response.data.token);
  localStorage.setItem("adminemail", Email);
  localStorage.setItem("adminUser", JSON.stringify(response.data.admin));

  // Save Admin ID
  if (response.data.admin?.id) {
    localStorage.setItem("adminId", response.data.admin.id);
  }

  navigate("/admin/dashboard", { replace: true });
}else {
          clearAdminSession();
          setError(response.data.message || "Invalid email or password");
        }
      })
      .catch(() => {
        setLoading(false);
        clearAdminSession();
        setError("Login failed. Please try again.");
      });
  };

 
  const handleLogin = (e) => {
    e.preventDefault();

    const emailError = regExpChecker("email", email);
    if (emailError) { setError(emailError); return; }

    const passwordError = regExpChecker("password", password);
    if (passwordError) { setError(passwordError); return; }

    setError("");
    adminLogin(email, password);
  };

 
  if (isAutoLogging) {
    return (
      <div style={{ height: "100vh" }} className="d-flex justify-content-center align-items-center">
        <Spinner style={{ height: 60, width: 60 }} />
      </div>
    );
  }

 
  return (
    <div className="admin-login-cont-ainer">

      {/* Loading Overlay */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}

      <div className="login-card">

        <div className="login-header">
          <h1>Admin Portal</h1>
          <p>Welcome back! Please login to continue</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>

          {/* EMAIL */}
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(regExpChecker("email", e.target.value));
              }}
              required
              placeholder="admin@example.com"
            />
          </div>

          {/* PASSWORD */}
          <div className="form-group">
            <label>Password</label>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(regExpChecker("password", e.target.value));
              }}
              required
              placeholder="Enter your password"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          {/* ERROR MESSAGE */}
          {error && <p style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>{error}</p>}

          {/* LOGIN BUTTON */}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>

        </form>
      </div>
    </div>
  );
};

export default AdminLogin;